import { ActionBar, Modal } from '@viapeople/components'
import { useState } from 'react'
import type { CycleRole, CycleRoleListInput } from '../../modules/cycles/tabs/types'
import { trpc } from '../../utils/trpc'
import { type Column, GenericTable } from '../GenericTable'

interface AddCycleRolesModalProps {
	isOpen: boolean
	excludedRoleIds: () => Set<string>
	onSelect: (roles: CycleRole[]) => void
	onClose: () => void
	cycleId: string
}

export const AddCycleRolesModal: React.FC<AddCycleRolesModalProps> = ({
	isOpen,
	excludedRoleIds,
	onSelect,
	onClose,
	cycleId,
}) => {
	const [selectedRoles, setSelectedRoles] = useState<CycleRole[]>([])

	const columns: Column<CycleRole & { customFields: Record<string, string> }>[] = [
		{
			field: 'displayName',
			label: 'Name',
			colSpan: 2,
			render: (role: CycleRole) => role.displayName,
		},
	]

	return (
		<Modal isOpen={isOpen} fullContent onClose={onClose} fullScreen title='Add Roles'>
			<div className='flex flex-col h-[calc(100vh-150px)]'>
				<GenericTable<CycleRole & { customFields: Record<string, string> }, CycleRoleListInput>
					queryOptionsGenerator={(options) => ({
						...trpc.admin.cycles.roles.list.queryOptions({
							...options,
							cycleId,
							notIn: Array.from(excludedRoleIds()),
						}),
					})}
					isInternal
					selectable
					onSelectionChange={(roles) => setSelectedRoles(roles)}
					columns={columns}
				/>
			</div>

			<ActionBar
				variant='modal'
				className='left-0 flex justify-end'
				rightActions={[
					{
						label: 'Cancel',
						variant: 'secondary',
						onClick: (e) => {
							e.preventDefault()
							onClose()
						},
					},
					{
						label: 'Add reviewers',
						variant: 'primary',
						onClick: (e) => {
							e.preventDefault()
							onSelect(selectedRoles)
							onClose()
						},
						disabled: selectedRoles.length === 0,
					},
				]}
			/>
		</Modal>
	)
}
